import { render } from "./InvisibleButton.vue?vue&type=template&id=1ced57ba&scoped=true"
import script from "./InvisibleButton.vue?vue&type=script&lang=js"
export * from "./InvisibleButton.vue?vue&type=script&lang=js"

import "./InvisibleButton.vue?vue&type=style&index=0&id=1ced57ba&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Github\\Wellen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ced57ba"]])

export default __exports__